import typeManager from "@cloud/TypeManager";
import * as THREE from "three";

import ParticleField from "./ParticleField";

// resources:
// https://www.khanacademy.org/math/multivariable-calculus/thinking-about-multivariable-function/ways-to-represent-multivariable-functions/a/vector-fields
const { floor, abs, sin, cos, round, random } = Math;
class ParticleStream extends ParticleField {
  constructor() {
    super();
    this.dispose = this.dispose.bind(this);
  }

  start() {
    if (window.innerWidth < 420) {
      const opts = this.inputs.get("particleOptions");
      opts.size = opts.size * 2;
    }

    const points = this.inputs.get("curvePoints");

    this.curve = new THREE.CatmullRomCurve3(
      points.map((p) => new THREE.Vector3(p.x, p.y, p.z))
    );
    this.inputs.setAutoUpdate(true);
    super.start();

    document.removeEventListener("mousemove", this.onMouseMove);
    this.reverseFlowDirection = this.inputs.get("reverseFlowDirection");

    this.inputs.listeners.add("curvePoints", this.regenerateCurve.bind(this));
  }
  regenerateCurve() {
    const points = this.inputs.get("curvePoints");
    if (!points || points.length <= 1) return;
    this.curve = new THREE.CatmullRomCurve3(
      points.map((p) => new THREE.Vector3(p.x, p.y, p.z))
    );
  }

  update(dt) {
    const { particleSystem, options, count, dim } = this;
    super.update(dt);

    const totalCount = count.x * count.z;

    for (var i = 0; i < totalCount; i++) {
      const x = i % count.x;
      const z = floor(i / count.x); //* ( 1 - 0.4 *   x / this.inputs.get("count").x )
      let speed = 0.005 * ((z % 3) + 1);
      speed *= ((z % 7) + 1 - 1 / ((z % 7) + 1)) * 0.4 + (((3 * z) % 5) + 1);
      if (sin(x) > 0.000001) speed *= abs(sin(x));

      let perc = (x / count.x + this.time * speed + x) % 1;

      options.blur = (1 - sin(perc)) ** 4;

      if (this.reverseFlowDirection) {
        perc = 1 - perc;
        options.blur = sin(perc) ** 4;
      }
      //

      const p = this.curve.getPoint(perc);

      options.position.copy(p);

      options.position.z = -dim.z / 2 + (z * dim.z) / count.z;
      options.color = false;

      particleSystem.spawnParticle(options);
    }
    //     this.bg.lookAt(this.me.camera.position)
  }
}

typeManager.registerClass("Comp.Field.ParticleStream", ParticleStream);
export default ParticleStream;
